import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { ErrorFilledIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React, { createContext, useContext } from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';
import Grid from './Grid.js';

var _excluded = ["className", "activeStep", "type", "defaultStep", "onStepSelect"],
  _excluded2 = ["active", "as", "caption", "className", "clickable", "children", "completed", "disabled", "error", "index", "name"];
var StepperContext = /*#__PURE__*/createContext({
  activeStep: '',
  onStepSelect: function onStepSelect() {}
});
var Stepper = function Stepper(_ref) {
  var className = _ref.className,
    activeStep = _ref.activeStep,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'horizontal' : _ref$type;
    _ref.defaultStep;
    var _onStepSelect = _ref.onStepSelect,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Stepper', _defineProperty({}, "--type-".concat(type), type), className);
  return /*#__PURE__*/React.createElement(StepperContext.Provider, {
    value: {
      activeStep: activeStep,
      onStepSelect: function onStepSelect(name) {
        return function (event) {
          return _onStepSelect && _onStepSelect(event, {
            name: name
          });
        };
      }
    }
  }, /*#__PURE__*/React.createElement(Grid.Container, _extends({
    spacing: "none",
    align: "flex-start",
    direction: type === 'vertical' ? 'column' : 'row',
    className: finalClasses
  }, otherProps)));
};
Stepper.displayName = 'Stepper';
var StepperItemIndex = function StepperItemIndex(_ref2) {
  var value = _ref2.value;
  if (!value) {
    return null;
  }
  if (isNaN(Number(value))) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value, "\xA0");
  } else {
    return "".concat(value, ". ");
  }
};
var StepperItem = function StepperItem(_ref3) {
  var _ref3$active = _ref3.active,
    active = _ref3$active === void 0 ? false : _ref3$active,
    _ref3$as = _ref3.as,
    As = _ref3$as === void 0 ? 'button' : _ref3$as,
    caption = _ref3.caption,
    className = _ref3.className,
    clickable = _ref3.clickable,
    children = _ref3.children,
    completed = _ref3.completed,
    disabled = _ref3.disabled,
    error = _ref3.error,
    index = _ref3.index,
    name = _ref3.name,
    otherProps = _objectWithoutProperties(_ref3, _excluded2);
  alertUserOfDeprecatedProps('Stepper', otherProps);
  var _useContext = useContext(StepperContext),
    activeStep = _useContext.activeStep,
    onStepSelect = _useContext.onStepSelect;
  alertUserOfDeprecatedProps('Stepper', otherProps);
  var finalClasses = classnames('C-Stepper__Step', {
    isActive: active || name && activeStep && name === activeStep,
    isClickable: clickable || As === 'button' || As === 'a' || As === 'Link',
    isCompleted: completed,
    isDisabled: disabled,
    isErrored: error
  }, className);
  return /*#__PURE__*/React.createElement(Grid.Item, {
    xs: true,
    className: "C-Stepper__Item",
    role: "tablist"
  }, /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses,
    disabled: disabled,
    role: "tab",
    "aria-live": "polite",
    "aria-selected": active,
    onClick: !disabled ? onStepSelect(name) : function () {}
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "C-Step__TopBar",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "C-Step__Text"
  }, children && /*#__PURE__*/React.createElement("h6", {
    className: "C-Step__Heading"
  }, error && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "hc-sr-only",
    role: "alert"
  }, "There is an error in:"), /*#__PURE__*/React.createElement(EnterpriseIcon, {
    className: "hc-mr-min",
    icon: ErrorFilledIcon,
    size: "inline"
  })), /*#__PURE__*/React.createElement(StepperItemIndex, {
    value: index
  }), children), caption && /*#__PURE__*/React.createElement("p", {
    className: "C-Step__Caption"
  }, caption))));
};
StepperItem.displayName = 'Stepper.Item';
Stepper.Item = StepperItem;

export { StepperItem, Stepper as default };
